import moment from 'moment';

export const sortGroupedQuoteDocuments = (o1, o2) => {
  const o1Date = moment(o1?.[1]?.UploadDate).valueOf();
  const o2Date = moment(o2?.[1]?.UploadDate).valueOf();
  return o2Date - o1Date;
};
